import { useContext, useState } from 'react';
import { MainModalFieldProps, ModalFieldStateEnum } from '../../../lib/types';
import { TableStoreContext } from '../../../stores/TableStoreContext';
import { ModalFieldsCombinedProps } from './types';
import { useCellState } from '../../../lib/hooks/useCellState';
import { CellLocation } from '../../../stores/types';

const usePresenter = (props: ModalFieldsCombinedProps): ModalFieldsCombinedProps => {
  const { cellColumn } = props;
  const tableStore = useContext(TableStoreContext);
  const selectedRow = tableStore.selectedRow || 0;
  const cellLocation: CellLocation = { row: selectedRow, column: cellColumn };
  const cellState = tableStore.tableState[selectedRow].cellStates[cellColumn];

  const {
    getCellSchema,
    getReferenceOptionsData,
    updateCellValue,
  } = useCellState(cellLocation);

  const [fieldState, setFieldState] = useState<ModalFieldStateEnum>('Default');

  const handleBlur = () => setFieldState('Default');

  const handleClick = () => setFieldState('FirstSelect');

  const handleDoubleClick = () => setFieldState('SecondSelect');

  const handleKeyDown = (
    event?: React.KeyboardEvent<HTMLDivElement | HTMLTextAreaElement>,
  ) => {
    if (event && ['Enter', 'Tab'].includes(event.key)) {
      setFieldState('Default');
    }
  };

  const updateModalFieldState = (newFieldState: ModalFieldStateEnum) => {
    setFieldState(newFieldState);
  };

  const mainModalFieldProps: MainModalFieldProps = {
    getCellSchema,
    handleBlur,
    handleClick,
    handleDoubleClick,
    handleKeyDown,
    getReferenceOptionsData,
    updateCellValue,
    updateModalFieldState,
    dataType: cellState.dataType,
    invalid: cellState.invalid,
    state: fieldState,
    value: cellState?.value,
  };

  return {
    ...props,
    modalAttachmentContent: { ...mainModalFieldProps },
    modalCodeContent: { ...mainModalFieldProps },
    modalDateContent: { ...mainModalFieldProps },
    modalImageContent: { ...mainModalFieldProps },
    modalLongTextContent: { ...mainModalFieldProps },
    modalMultiSelectContent: { ...mainModalFieldProps },
    modalSingleSelectContent: { ...mainModalFieldProps },
    modalTextContent: { ...mainModalFieldProps },
  };
};

export default usePresenter;
